import apiService from "../../api/api.service";
import {
  ProductReviewResponse,
  ReviewActionResponse,
  ReviewListResponse,
  ReviewFilters,
  ReviewVisualsResponse,
} from "./productReview.types";

/**
 * Fetch product reviews page data (sections)
 */
export const fetchProductReviews = (productSlug: string) => {
  return apiService.get<ProductReviewResponse>(
    `/products/${productSlug}/reviews`,
  );
};

/**
 * Fetch product reviews list with filters
 * Filters are sent as arrays: rating[]=2&rating[]=3&topic[]=price&topic[]=quality
 */
export const fetchProductReviewsList = (
  productSlug: string,
  filters?: ReviewFilters,
) => {
  const params: Record<string, string | string[]> = {};

  if (filters) {
    if (filters.rating && filters.rating.length > 0) {
      params["rating[]"] = filters.rating.map((r) => r.toString());
    }
    if (filters.topic && filters.topic.length > 0) {
      params["topic[]"] = filters.topic;
    }
    if (filters.seller_id) {
      params["seller_id"] = filters.seller_id.toString();
    }
    if (filters.per_page) {
      params["per_page"] = filters.per_page.toString();
    }
    if (filters.page) {
      params["page"] = filters.page.toString();
    }
    if (filters.sort) {
      params["sort"] = filters.sort;
    }
    if (filters.search) {
      params["search"] = filters.search;
    }
  }

  return apiService.get<ReviewListResponse>(
    `/products/${productSlug}/reviews-list`,
    { params },
  );
};

/**
 * Fetch review visuals (photos) with pagination
 */
export const fetchReviewVisuals = (
  productSlug: string,
  page: number = 1,
  perPage: number = 20,
) => {
  return apiService.get<ReviewVisualsResponse>(
    `/products/${productSlug}/review-visuals`,
    {
      params: {
        page,
        per_page: perPage,
      },
    },
  );
};

/**
 * Perform action on review (like/complaint)
 */
export const reviewAction = (
  reviewId: number,
  actionType: "like" | "complaint",
) => {
  return apiService.post<ReviewActionResponse>(
    `/customers/reviews/${reviewId}/action`,
    {
      action_type: actionType,
    },
  );
};
